/**
 * Message boxes show the whole text — no inner scrollbar on a 600-character InMail (Sofia, Oct 15
 * 2026). Rows from the text itself: each line wraps at roughly `perRow` characters.
 */
export function autoRows(text: string, { min = 4, max = 24, perRow = 85 } = {}) {
  const rows = `${text || ''}`.split('\n').reduce((n, line) => n + Math.max(1, Math.ceil(line.length / perRow)), 0);
  return Math.min(max, Math.max(min, rows + 1));
}


/** The one card frame on the queue (profile check, InMail, follow-up): same edge, corner, shadow. */
export const CARD_FRAME =
  'overflow-hidden rounded-md border border-solid border-[#C9CED6] bg-white shadow-[0_1px_4px_rgba(16,24,40,0.08)]';
/** Its title bar, so every card starts with the same row at the same height. */
export const CARD_HEAD =
  'flex flex-wrap items-baseline justify-between gap-x-3 border-b border-solid border-x-0 border-t-0 border-[#E9EAEC] bg-[#F7F9FC] px-4 py-2';
export const CARD_TITLE = 'text-xs font-semibold uppercase tracking-wide text-[#1A1A1A]';
